export default "__VITE_ASSET__BGzG_Elk__"